module.exports = __webpack_public_path__ + "img/ellipse.6e58fe27.svg";